module.exports = __webpack_public_path__ + "static/media/snapappcounter.cfe40f3e.png";